export type Sponsor = {
    name: string
    image: string
    url?: string
}

const getSponsors = (): Sponsor[] => {
    return [
       {
            name: 'Pivovar Bakalář',
            image: 'assets/img/sponsors/bakalar.png',
            url: 'https://www.pivobakalar.cz/',
        },
        {
            name: 'Skysight.io',
            image: 'assets/img/sponsors/skysight.png',
            url: 'https://skysight.io/',
        },
        {
            name: 'PG',
            image: 'assets/img/sponsors/pgLogo.png',
            url: 'https://pg.jobs.cz/technik',
        },
        {
            name: 'PG',
            image: 'assets/img/sponsors/pg.png',
            url: 'https://pg.jobs.cz/technik',
        },
        {
            name: 'Kamenictví HAVLÍČEK',
            image: 'assets/img/sponsors/konecny.png',
            url: 'https://kamenosocharstvi-havlicek.webnode.cz/',
        },
        {
            name: 'Staclo.host',
            image: 'assets/img/sponsors/staclo.jpg',
            url: 'https://staclo.host/',
        },
    ]
}

const useSponsors = (): Sponsor[] => {
    const sponsors = getSponsors()

    return sponsors
}

export default useSponsors
